module.exports = function() {
  return new Worker(__webpack_public_path__ + "e856c48d7041e78aa91a.worker.js");
};